import { ConsentValue, GoogleAnalyticsConsentOptions, TCData } from '../types'
import isDevEnvironment from '../util/isDevEnvironment'
import ReactGA from 'react-ga4'

const ConsentValues: Record<string, ConsentValue> = {
	GRANTED: 'granted',
	DENIED: 'denied',
}

const DEFAULT_GA_CONSENT_OPTIONS: GoogleAnalyticsConsentOptions = {
	ad_storage: ConsentValues.DENIED,
	ad_user_data: ConsentValues.DENIED,
	ad_personalization: ConsentValues.DENIED,
	analytics_storage: ConsentValues.DENIED,
}

export function initialiseAnalytics() {
	ReactGA.gtag('consent', 'default', DEFAULT_GA_CONSENT_OPTIONS)
	ReactGA.initialize('G-6208P8TSPT', {
		testMode: isDevEnvironment(),
	})
}

export function updateAnalytics(tcData: TCData) {
	if (!tcData) return

	const { GRANTED, DENIED } = ConsentValues

	if (tcData.gdprApplies === false) {
		// GDPR does not apply, so treat as full consent
		ReactGA.gtag('consent', 'update', {
			ad_storage: GRANTED,
			ad_user_data: GRANTED,
			analytics_storage: GRANTED,
			ad_personalization: GRANTED,
		})
		return
	}

	// Check if TCF data is available and user has given consent – if not we
	// cannot proceed
	if (tcData.eventStatus !== 'tcloaded' && tcData.eventStatus !== 'useractioncomplete') return

	const vendorConsents = tcData.vendor?.consents || []
	const purposeConsents = tcData.purpose?.consents || []

	// NOTE: the lists of purposes/vendors are objects with numeric keys, starting with 1 (as opposed to zero-based arrays)
	const selectAdvertising = purposeConsents[2]
	const personalisedAdvertising = purposeConsents[3] || purposeConsents[4]
	const measureAdPerformance = purposeConsents[7]
	const measureContentPerformance = purposeConsents[8]

	// Also check if they have specified consent for Google specifically
	const vendorGoogle = !!vendorConsents[755]

	ReactGA.gtag('consent', 'update', {
		ad_storage: vendorGoogle && measureAdPerformance ? GRANTED : DENIED,
		analytics_storage: measureContentPerformance ? GRANTED : DENIED,
		ad_user_data: vendorGoogle && (selectAdvertising || personalisedAdvertising) ? GRANTED : DENIED,
		ad_personalization: vendorGoogle && personalisedAdvertising ? GRANTED : DENIED,
	})
}
